import { render, staticRenderFns } from "./storesOnPromoTable.vue?vue&type=template&id=67dcd72d&"
import script from "./storesOnPromoTable.vue?vue&type=script&lang=js&"
export * from "./storesOnPromoTable.vue?vue&type=script&lang=js&"
import style0 from "./storesOnPromoTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VAutocomplete,VBtn,VBtnToggle,VCard,VCardActions,VCardTitle,VCol,VContainer,VDataTable,VDialog,VDivider,VIcon,VMenu,VOverlay,VRow,VSimpleCheckbox,VSpacer,VTextField,VToolbar,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2538197670/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67dcd72d')) {
      api.createRecord('67dcd72d', component.options)
    } else {
      api.reload('67dcd72d', component.options)
    }
    module.hot.accept("./storesOnPromoTable.vue?vue&type=template&id=67dcd72d&", function () {
      api.rerender('67dcd72d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stores/storesOnPromoTable.vue"
export default component.exports